import { ACADEMIC_YEAR_RETRIEVED } from './academic-year-actions';

const initialState = {
    startDate: null,
    endDate: null,
    year: null
};

/**
 * AcademicYear Reducer
 *
 * Consumes ACADEMIC_YEAR_RETRIEVED action
 *
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - current start and end dates of academic year
 */
export default function (state = initialState, action) {
    if (!action) return state;

    switch (action.type) {
    case ACADEMIC_YEAR_RETRIEVED:
        return action.payload;

    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./containers/overview/academic-year-reducer.js